import { constants } from "../config/constants"
import { api } from "../plugins/api_settings"

export default {
  methods: {
    $init(token, data) {
      /* AUTH */
      this.$store.commit("auth/SET_CURRENT_USER", {
        user: data,
        token: token
      })

      /* SETTINGS */
      this.$store.dispatch("settings/init", data.settings)
      let locale = data.settings.find((i) => i.key == "locale").value || "en"

      /* FRONT END LOCALE */
      let fe_locale = this.$store.getters["settings/fe_locale"]
      let path = this.$router.currentRoute.path

      if ((path.startsWith("/f/") || path.startsWith("/auth/")) && fe_locale) {
        // If previous route path is login page, use the locale from the user's settings
        if (path.startsWith("/auth/") && path.endsWith("/login")) {
          locale = locale
        } else {
          locale = fe_locale
        }
      }
      this.$i18n.locale = locale
    },
    $setPageTitle: function (title) {
      this.$store.dispatch("master/setPageTitle", title)
    },
    $setCurrentModule: function (module) {
      this.$store.dispatch("master/setCurrentModule", module)
    },
    $setCurrentPath: function (module) {
      this.$store.dispatch("master/setCurrentPath", module)
    },
    $toggleDrawer: function (bool = undefined) {
      let drawer = this.$store.getters["master/drawerOpen"]
      drawer = !drawer

      if (bool !== undefined) {
        drawer = bool
      }

      this.$store.dispatch("master/setDrawerOpen", drawer)
    },
    $globalMessages(message, type, show = true, code = null, extras = null) {
      this.$store.dispatch("master/setAlert", {
        message: message,
        type: type == "" ? "success" : type,
        show: show,
        code: code,
        extras: extras
      })
    },
    $formatErrorMessages(errors) {
      let messages = ""

      if (typeof errors === "string") {
        messages = errors
      } else {
        _.map(errors, function (data) {
          messages += _.map(data).join("\n\t")
        })
      }

      return messages
    },
    $setAuthorization(token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`
    },
    $checkAllCookies() {
      let access_token = this.$cookies.get(`${this.COOKIE_PREFIX}access_token`)

      if (access_token) {
        return true
      }

      return false
    },
    $clearCookies() {
      this.$cookies.remove(`${this.COOKIE_PREFIX}access_token`)
    },
    $can: function (action, local = false) {
      let vm = this
      let bool = false
      let user = local ? this.$store.getters["auth/localUser"] : this.$store.getters["auth/user"]

      _.forEach(user.roles, function (role) {
        if (role.slug == "system-developer") bool = true

        if (!bool) {
          _.forEach(role.permissions, function (permission) {
            if (permission == action) bool = true
          })
        }
      })

      return bool
    },
    $hasRole: function (action) {
      let bool = false
      let user = this.$store.getters["auth/user"]

      _.forEach(user.roles, function (role) {
        if (role.slug == action || role.slug == "system-developer") bool = true
      })

      return bool
    },
    $addLog: function (user_id, action_model, action_id, action, before_value = "", after_value = "") {
      let user = this.$store.getters["auth/localUser"]

      axios
        .post(this.API_URL + "log", {
          user_id: user_id ? user_id : user.id,
          action: action,
          action_model: action_model,
          action_id: action_id,
          before_value: before_value,
          after_value: after_value
        })
        .then((res) => { })
        .catch((err) => console.log(err))
    },
    $getCity(code, country) {
      if (country) {
        country = this.countryAlpha2(country)
      }

      if (!country) {
        country = "NO"
      }

      let bringAxios = axios.create({
        headers: {
          "X-MyBring-API-Uid": this.BRING_API_UID,
          "X-MyBring-API-Key": this.BRING_API_KEY
        }
      })

      return bringAxios.get(this.BRING_API_URL + `postalCode/${country}/getCityAndType/${code}.json`)
    },
    $queryString: function (pagination, search_params) {
      let sort_by = "",
        sort_order = "asc"
      let queryString = Object.keys(search_params)
        .map((key) => "query_" + key + "=" + (search_params[key] === undefined ? "" : search_params[key]))
        .join("&")
      if (pagination.multisort) {
      } else {
        if (pagination.sortBy.length == 1) {
          sort_by = pagination.sortBy[0]
        }

        if (pagination.sortDesc && pagination.sortDesc.length == 1) {
          sort_order = pagination.sortDesc[0] ? "desc" : "asc"
        }
      }

      let query = `page=${pagination.page}&sort_by=${sort_by}&sort_order=${sort_order}&rows_per_page=${pagination.itemsPerPage}&${queryString}`

      return query
    },
    $getLocalStorage(key, type) {
      let item = localStorage.getItem(key)

      if(item) {
        return item
      }

      // defaults
      if(type == 'page') {
        return 1;
      }
    },
    $getSetting: function (key) {
      let user = localStorage.getItem("__crrntUser")

      if (user) {
        user = JSON.parse(user)

        let setting = user.settings.find((i) => i.key == key)

        if (setting && setting.value) {
          if (key == "rows_per_page") {
            return Number(setting.value)
          }

          return setting.value
        }
      }

      // return default value
      if (key == "rows_per_page") {
        return constants.SETTING_DEFAULT_ROWS_PER_PAGE
      }
      if (key == "locale") {
        return constants.SETTING_DEFAULT_LOCALE
      }
    },
    $updateSetting: function (key, value) {
      this.$store.dispatch("settings/update", { key: key, value: value })
    },
    $updateSettingDB: function (key, value) {
      this.$store.dispatch("settings/updatedb", { key: key, value: value })
    },
    $localeChange(locale) {
      let vm = this

      let user = this.$store.getters["auth/user"]
      let data = []

      data.push({ key: "locale", value: locale })

      axios
        .post(this.API_URL + "setting", {
          user_id: user.id,
          data: JSON.stringify(data)
        })
        .then((res) => {
          vm.$i18n.locale = locale
          vm.$updateSetting("locale", locale)
        })
        .catch((err) => console.log(err))
    },
    $classFormatDuration: function (data) {
      let duration = data.duration
      let duration_type = data.duration_type

      return duration + " " + this.$dd_classes_duration_type(duration_type)
    },
    $getDefaultDropdown: function (data) {
      let item = data.find((i) => i.default == 1)

      return item ? item.key : null
    },
    $dateFormatChecker: function (val, format = null) {
      if (format == null) {
        format = this.DATE_FORMAT
      }

      let checker = this.moment(val, format, true)
      let date = null

      if (checker.isValid()) {
        date = this.moment(val, format).format(this.MYSQL_DATE_FORMAT)
      }

      return date
    },
    $dateFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.DATE_FORMAT
      }

      let checker = this.moment(val, format, true)
      let date = val

      if (checker.isValid()) {
        date = this.moment(val, format).format(this.MYSQL_DATE_FORMAT)
      }

      return date
    },
    $dateFormatGetter: function (val) {
      return this.moment(val, this.MYSQL_DATE_FORMAT, true).isValid() ? this.moment.utc(val).format(this.DATE_FORMAT) : val
    },
    $timeFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.TIME_FORMAT
      }

      let checker = this.moment(val, format, true)
      let time = val

      if (checker.isValid()) {
        time = this.moment(val, format).format(this.TIME_FORMAT)
      }

      return time
    },
    $timeFormatGetter: function (val) {
      return this.moment(val, this.MYSQL_TIME_FORMAT, true).isValid()
        ? this.moment.utc(val, this.TIME_FORMAT).format(this.TIME_FORMAT)
        : val
    },
    $priceFormatGetter: function (val) {
      if (val !== null) {
        if (!isNaN(val)) {
          val = Intl.NumberFormat("nb-NO").format(val)
          val = val.replace(/[\s]/g, "")
          return val
        }
      }

      return null
    },
    $priceFormatSetter: function (val) {
      if (val) {
        val = val.replace(/[\s]/g, "")
        val = val.replace(/[,]/g, ".")

        if (!isNaN(val)) {
          return Intl.NumberFormat("en-US", { useGrouping: false }).format(val)
        }
      }

      return null
    },
    $keyDown_LetterOnly: function (event, stricLetterOnly = false) {
      var regex = /^[a-z_ ]+$/i

      if (stricLetterOnly) {
        regex = /^[a-z]+$/i
      }

      var char = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(char)) {
        event.preventDefault()
      }

      return true
    },
    $keyDown_LetterDigitOnly: function (event) {
      var regex = /^[a-z0-9]+$/i

      var char = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(char)) {
        event.preventDefault()
      }

      return true
    },
    $keyDown_PriceOnly: function (event) {
      var regex = /^[0-9,]+$/i

      var char = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(char)) {
        event.preventDefault()
      }

      return true
    },
    $keyDown_IntOnly: function (event) {
      event = event ? event : window.event
      var charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault()
      } else {
        return true
      }
    },
    $locale_bcp47: function (val) {
      let locale = this.$getSetting("locale")

      if (val) locale = val

      if (locale == "no") locale = "nb"

      return locale
    },
    $nl2br(str) {
      if (str) {
        return str.replace(new RegExp("\r?\n", "g"), "<br />")
      }

      return ""
    },
    $diffObj: function (object, base) {
      function changes(object, base) {
        return _.transform(object, function (result, value, key) {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value
          }
        })
      }
      return changes(object, base)
    },
    $leaveFormConfirmation: function (next, obj1, obj2, action, formValid = true) {
      if (!_.isEqual(obj1, obj2)) {
        this.$awn.confirm(
          this.$t("global.save_changes"),
          () => {
            action()

            if (formValid) {
              next()
            } else {
              next(false)
            }
          },
          () => {
            next()
          },
          {
            labels: {
              confirmOk: this.$t("global.yes"),
              confirmCancel: this.$t("global.no")
            }
          }
        )
      } else {
        next()
      }
    },
    $generatePassword: function (length = 12) {
      const specials = "!@#$%^&*()~-=_[]{}+"
      const lowercase = "abcdefghijklmnopqrstuvwxyz"
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
      const numbers = "0123456789"
      const all = specials + lowercase + uppercase + numbers

      let password = ""

      password += this.$pick(password, specials, 1, 1)
      password += this.$pick(password, lowercase, 1, 1)
      password += this.$pick(password, uppercase, 1, 1)
      password += this.$pick(password, numbers, 1, 1)
      password += this.$pick(password, all, length - 4)

      return this.$shuffle(password)
    },
    $pick: function (exclusions, string, min, max) {
      var n,
        chars = ""

      if (max === undefined) {
        n = min
      } else {
        n = min + Math.floor(Math.random() * (max - min + 1))
      }

      var i = 0
      while (i < n) {
        const character = string.charAt(Math.floor(Math.random() * string.length))
        if (exclusions.indexOf(character) < 0 && chars.indexOf(character) < 0) {
          chars += character
          i++
        }
      }

      return chars
    },
    $shuffle: function (string) {
      var array = string.split("")
      var tmp,
        current,
        top = array.length

      if (top)
        while (--top) {
          current = Math.floor(Math.random() * (top + 1))
          tmp = array[current]
          array[current] = array[top]
          array[top] = tmp
        }

      return array.join("")
    },

    $getAppVersion: function () {
      return process.env.VUE_APP_VERSION
    },
    $checkAppVersion() {
      let vm = this

      vm.$store.dispatch("master/setAxiosHideLoader", true)

      axios
        .get(vm.API_URL + "version")
        .then((res) => {
          let api_version = res.data.version
          let app_version = process.env.VUE_APP_VERSION
          let isnew = api_version != app_version

          vm.$store.dispatch("master/setNewVersionSnackbar", isnew)
        })
        .catch((err) => console.log(err))
    },
    $handleServerSideError(error) {
      let locale = this.$i18n.locale

      switch (error.response && error.response.status) {
        case 404:
          this.$awn.alert(error.response.data.message)

          // if (this.$isLoggedIn() === true) this.$router.push(`${this.APP_URL}dashboard`)
          // else this.$router.push(`${this.AUTH_URL}${locale}/login`)
          break
        case 422:
          let message = this.$t("global.something_went_wrong")
          if (error.response.data.errors) {
            message = Object.values(error.response.data.errors)[0][0]
          } else {
            if (error.response.data.message) {
              message = error.response.data.message
            }
          }

          this.$awn.alert(message)
          break
        case 401:
          this.$awn.alert(this.$t("auth.authFail"))
          this.$router.push(`${this.AUTH_URL}${locale}/login`)
          break
        case 499:
          this.$awn.alert(error.response.data.message)
          this.$logout()
          break
        default:
          this.$awn.alert(this.$t("global.something_went_wrong"))
          break
      }
    },
    $isValidJSONString(str) {
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
      return true
    },
    $arrayBufferValidation(string) {
      let data = this.$arrayBufferToString(string)

      try {
        if (this.$isValidJSONString(data) && data) {
          var json = JSON.parse(data)

          if (json.status == "error") {
            let errors = this.$formatErrorMessages(json.message || this.$t("auth.error"))
            this.$globalMessages(errors, "error")
            window.scrollTo({ top: 0, behavior: "smooth" })
          }

          return false
        }
      } catch (e) {
        return true
      }

      return true
    },
    $arrayBufferToString(buffer) {
      try {
        return String.fromCharCode.apply(null, new Uint8Array(buffer))
      } catch (e) {
        return null
      }
    },
    $api1881SearchVAT(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/lookup/organizationnumber/${search}`)
    },
    $api1881SearchName(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/search/company?query=${search}&limit=10`)
    },
    $api1881SearchID(id) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/lookup/id/${id}`)
    },
    $smsCounter(text, overrideTags = []) {
      let text_per_sms = 160
      let sms_length = text ? text.length : 0

      // set default tags and counts
      let tags = []
      tags.push({ tag: "{course_name}", count: 45 })
      tags.push({ tag: "{organisation_name}", count: 25 })
      tags.push({ tag: "{link}", count: 50 }) // e.g https://avalia.kurswebtest.no/f/url/6107a66e40dfe

      // check if we need to override the count of tags
      overrideTags.forEach((item) => {
        let idx = tags.findIndex((i) => i.tag == item.tag)
        if (idx >= 0) {
          tags[idx] = overrideTags.find((i) => i.tag == item.tag)
        }
      })

      // calculate sms length
      tags.forEach((item) => {
        if (text && text.indexOf(item.tag) !== -1) {
          let regex = new RegExp(`${item.tag}`, "g")
          let count = (text.match(regex) || []).length

          sms_length = sms_length - item.tag.length * count // remove the count of the found tag
          sms_length = sms_length + item.count * count // add the new count
        }
      })

      let no_of_sms = Math.ceil(sms_length / text_per_sms) + " SMS"
      return {
        html:
          "<span class='float-left'>" +
          no_of_sms +
          "</span>  <span class='sms-counter'> Approx. " +
          sms_length +
          " / " +
          text_per_sms * 2 +
          "</span>",
        count: sms_length
      }
    },
    $slug(val) {
      if (val) {
        return val
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "")
      }

      return null
    },
    $formatPhoneNumber(mobile, code) {
      let data = null

      if (mobile && code) {
        mobile = mobile.replace(/[^0-9]+/g, '')
        data = "+" + code + mobile
      }

      return data
    },
    $generateToken(length){
      //edit the token allowed characters
      var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
      var b = [];  
      for (var i=0; i<length; i++) {
          var j = (Math.random() * (a.length-1)).toFixed(0);
          b[i] = a[j];
      }
      return b.join("");
    },
    $formatAPICompanyName(str) {
      let abbrWords = /^(AS|ASA|A\/S|DA|AB|SRL|SA)$/i;
      let words = str.split(' ');  

      words = words.map(function(word, index) {
        if (index > 0 && ~word.search(abbrWords)) {
          return word;                 // If it's a small word, don't change it.
        }
        
        if (~word.lastIndexOf('.', 1)) { // If it contains periods, it's an abbreviation: Uppercase.
          return word.toUpperCase();   // lastIndexOf to ignore the last character.
        }

        // Capitalize the fist letter if it's not a small word or abbreviation.
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase(); 
      });
      
      return words.join(' ');
    }
  }
}
